import Content from './components/Content.js';

export default function App() {

  //The return value of the app => rendering content
  return (
    <Content />
  );
  }
  